import Alert from '@mui/material/Alert';
import type { Breakpoint, SxProps, Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { RycLogo } from '@onesource/icons';

import { HeaderSection } from '../core/header-section';
import { LayoutSection } from '../core/layout-section';
import { CompactContent, Main } from './main';

// ----------------------------------------------------------------------

export type SimpleLayoutProps = {
  sx?: SxProps<Theme>;
  children: React.ReactNode;
  header?: {
    sx?: SxProps<Theme>;
  };
  content?: {
    compact?: boolean;
  };
};

export function SimpleLayout({ sx, children, header, content }: SimpleLayoutProps) {
  const theme = useTheme();
  const layoutQuery: Breakpoint = 'md';

  return (
    <LayoutSection
      /** **************************************
       * Header
       *************************************** */
      headerSection={
        <HeaderSection
          layoutQuery={layoutQuery}
          slotProps={{ container: { maxWidth: false } }}
          sx={header?.sx}
          slots={{
            topArea: (
              <Alert severity="info" sx={{ display: 'none', borderRadius: 0 }}>
                This is an info Alert.
              </Alert>
            ),
            leftArea: <RycLogo color={theme.palette.primary.light} width="130px" height="60px" />,
            // rightArea: (
            //   <Link href="#" component={RouterLink} color="inherit" sx={{ typography: 'subtitle2' }}>
            //     Need help?
            //   </Link>
            // ),
          }}
        />
      }
      /** **************************************
       * Footer
       *************************************** */
      footerSection={null}
      /** **************************************
       * Style
       *************************************** */
      sx={sx}
    >
      <Main>{content?.compact ? <CompactContent layoutQuery={layoutQuery}>{children}</CompactContent> : children}</Main>
    </LayoutSection>
  );
}
